import React from 'react';
import Slider from 'react-slick';
import { images } from '../../../assets/images'
import { renderImage } from '../../../Components/helper/image';


/* function SampleNextArrow(props) {
    const { className, onClick } = props;
    return (
        <div
            className={className}
            onClick={onClick}
        >
            <i className="far fa-angle-right"></i>
        </div>
    );
}

function SamplePrevArrow(props) {
    const { className, onClick } = props;
    return (
        <div
            className={className}
            onClick={onClick}
        >
            <i className="far fa-angle-left"></i>
        </div>
    );
} */

function TechnologiesSlider(props) {
    var settings = {
        autoplay: true,
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 6,
        slidesToScroll: 1,
        arrows: false,
        // nextArrow: <SampleNextArrow />,
        // prevArrow: <SamplePrevArrow />,
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 6,
                }
            },
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 4,
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 3,
                }
            },
            {
                breakpoint: 400,
                settings: {
                    slidesToShow: 2,
                }
            }
        ]
    };
    return (
        <div className="technologies_items">
            <Slider {...settings}>
            {props.item && props.item.technology_partners.map((item, index) => (
                <div key={index} className="technology_item_parent">
                    <div className="technology_item">
                        <img src={renderImage(item,'medium')} alt="..." className="img-fluid d-block mx-auto" />
                    </div>
                </div>
            ))}
            </Slider>
        </div>
    );
}

export { TechnologiesSlider };
